import React from "react"
import { PreStyledComponents } from "@life-without-barriers/react-components"

const HelpfulLinks = () => {
  const { PinkHoverLink } = PreStyledComponents
  return (
    <div className="mt4">
      <p className="ts-display-5 color-lwb-grey">
        ...or visit these helpful links:
      </p>
      <ul className="list ma0 mt3 pa0 flex flex-wrap items-center justify-center dib-l copy">
        <li className="mh2-ns w-50 w-auto-ns">
          <PinkHoverLink href="/about-us" title="About Life Without Barriers">
            About us
          </PinkHoverLink>
        </li>
        <li className="mt0 mt2-l mh2-ns w-50 w-auto-ns">
          <PinkHoverLink href="/find-a-service" title="Find a service">
            Find A Service
          </PinkHoverLink>
        </li>
        <li className="mt3 mt0-ns mt2-l mh2-ns w-50 w-auto-ns">
          <PinkHoverLink
            href="/contact-us"
            title="Contact Life Without Barriers"
          >
            Contact us
          </PinkHoverLink>
        </li>
      </ul>
    </div>
  )
}

export default HelpfulLinks
